const state = () => ({
    editableItem: false,
    // entry, main, ending
    control: 'entry'
})

const mutations = {
    setEditableItem(state, { data }) {
        state.editableItem = data
    },
    clearEditableItem(state) {
        state.editableItem = false
    },
    setControl(state, { control }) {
        state.control = control
    },
    clearAll(state) {
        state.editableItem = false,
        state.control = 'entry'
    }
}

const actions = {
    async setEditableItem({ commit }, { data }) {
        commit('setEditableItem', { data })
    },
    async clearEditableItem({ commit }) {
        commit('clearEditableItem')
    },
    async setControl({ commit }, { control }) {
        commit('setControl', { control })
    },
    async clearAll({ commit }) {
        commit('clearAll')
    }
}

const getters = {
    editableItem: state => state.editableItem,
    control: state => state.control
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};